export enum ContactType {
  VOICE_CONTACT = 'VoiceContact',
}
